import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './NavBar.css';
import CultureCompassIconNBG from '../Images/CCLogoNBG.png';
import SearchBar from './SearchBar';
import { useAuth } from '../../AuthContext';
import DropdownMenu from './DropdownMenu';

function NavBar() {
  const { isLoggedIn, logout } = useAuth();
  const navigate = useNavigate();

  // This function will be called when the Logout button is clicked
  const handleLogout = () => {
    logout(); // Call the logout method provided by useAuth
    alert('Logged out successfully!');
    navigate('/'); // Redirect the user to the homepage or login page
  };

  const handleSearch = (query) => {
    const options = query.split(',').map((option) => option.trim().toLowerCase());
    const validOptions = [
      'canada',
      'china',
      'philippines',
      'venezuela',
      'food',
      'festivals',
      'language',
      'traditions',
      'touristic places',
      'beginner',
      'intermediate',
      'advanced',
      'all levels',
    ];

    const isValidQuery = options.every((option) => validOptions.includes(option));

    if (isValidQuery) {
      const filterUrl = `/filtered-surveys/${query}`;
      navigate(filterUrl);
    } else {
      alert('Invalid search query. Please enter valid options.');
    }
  };

  return (
    // Navbar Functions are here!!!
    <Navbar expand="lg" className="bg-light-green custom-navbar">
      <Container>
        <Navbar.Brand as={Link} to="/" className="custom-brand">
          <img src={CultureCompassIconNBG} alt="Culture Compass Icon" className="brand-icon" />
          <strong className="custom-brand-text">Culture Compass</strong>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto custom-nav-group">
            <Nav.Link as={Link} to="/" className="custom-nav-link"><strong>Home</strong></Nav.Link>
            <div className='dropdownMenu'>
              <DropdownMenu />
            </div>
            <Nav.Link as={Link} to="/surveys" className="custom-nav-link"><strong>Surveys</strong></Nav.Link>
            <Nav.Link as={Link} to="/scoreboard" className="custom-nav-link"><strong>Scoreboard</strong></Nav.Link>
            <Nav.Link as={Link} to="/FeedbackForm" className="custom-nav-link"><strong>Feedback</strong></Nav.Link>
            {/* Other navigation links */}
            {isLoggedIn ? (
              // Use the handleLogout function on click event of the Logout button
              <Nav.Link as="button" onClick={handleLogout} className="custom-nav-link" style={{ cursor: 'pointer' }}><strong>Logout</strong></Nav.Link>
            ) : (
              <>
                <Nav.Link as={Link} to="/login" className="custom-nav-link"><strong>Login</strong></Nav.Link>
                <Nav.Link as={Link} to="/signup" className="custom-nav-link"><strong>Signup</strong></Nav.Link>
              </>
            )}
          </Nav>
          <div className='searchBar'>
            <SearchBar className="custom-search-bar" handleSearch={handleSearch} />
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
